import {
  ResponsiveSection,
  Stack,
  Text,
  Button,
  Link,
  ButtonBase,
} from '@stitch-fix/mode-react';

export type SuccessScreenProps = {
  email: string;
  onResendEmailClick: (email: string) => void;
  onBackToSignInOptionsClick: () => void;
};

export const SuccessScreen = ({
  email,
  onResendEmailClick,
  onBackToSignInOptionsClick,
}: SuccessScreenProps) => {
  return (
    <ResponsiveSection
      my={2}
      gutter={{ sm: 'standard', lg: 'none' }}
      minHeight="40vh"
    >
      <Stack spacing={0} hAlign="center">
        <Text mb="1rem" align="center" setting="title-large" as="h1">
          Check your email for a<br />
          sign in link
        </Text>
        <Text
          setting="body-medium"
          align="center"
          mb="2rem"
          data-testid="success-message"
        >
          We&apos;ve sent a link to <strong>{email}</strong>
        </Text>
        <Text setting="body-medium" align="center" mb="2rem">
          Didn&apos;t get the email?
          <Button variant="text" onClick={() => onResendEmailClick(email)}>
            Resend email
          </Button>
        </Text>

        <Text setting="body-medium-fixed">
          <Link
            as={ButtonBase}
            onClick={() => onBackToSignInOptionsClick()}
            mx="auto"
          >
            Back to sign-in options
          </Link>
        </Text>
      </Stack>
    </ResponsiveSection>
  );
};
